import React from 'react';
import PropTypes from 'prop-types';
import { RenderModule } from 'holocron';
import { Heading } from '@americanexpress/dls-react';
import { useConditionalFeature } from '@americanexpress/conditional-features';
import clsx from 'clsx';
import style from './Hero.scss';
import getLineOfBusinessFromPath from '../../utils/getLineOfBusinessUtils';
import AbandonHotel from '../AbandonHotel/AbandonHotel';
import { MODULE_NAME, ADVISORY_MODULE_NAME, SEARCH_MODULE_NAME } from '../../constants/modules';
import { useDataFromOneCms } from '../../fetchye/useOneCmsFetchye';
import { DISABLE_PACKAGES_FF } from '../../constants/oneXpConstants';
import { HOTELS } from '../../constants/lineOfBusinessConstants';
import { hasDisablePackagesRule } from '../../constants/featureRulesConstants';
import { useFeatureFlagWithProperties } from '../../thunks/useFeatureFlagWithProperties';

const MosaicHero = ({
  selectedTab,
  setSelectedTab,
  pathname,
}) => {
  const isPackagesDisabledByRule = useConditionalFeature(hasDisablePackagesRule);
  const isPackagesDisabledByFF = useFeatureFlagWithProperties(DISABLE_PACKAGES_FF);
  const isPackagesDisabled = isPackagesDisabledByRule || isPackagesDisabledByFF;

  const dataFromOneCms = useDataFromOneCms('hero');
  const { header } = dataFromOneCms?.[selectedTab || HOTELS] || {};

  return (
    <div data-testid={`${MODULE_NAME}-hero-variant-no-image`} className={style.mosaicHero}>
      <div className="flex flex-column flex-align-items-center container pad-0-lr-xs-down pad-4-tb-sm-up margin-2-b-sm-up">
        <RenderModule moduleName={ADVISORY_MODULE_NAME} />
        <AbandonHotel extraDlsStyles="pad-0" />
        <div
          className={clsx(
            'dls-white-bg flex flex-column pad-2-t-xs-down pad-3-xs-up width-full margin-t-sm-up',
            style.searchBlock
          )}
        >
          <Heading level={1} variant="serif-large-regular" className="flex flex-align-self-center text-align-center">
            {header}
          </Heading>
          <RenderModule
            moduleName={SEARCH_MODULE_NAME}
            props={{
              theme: 'white',
              activeTab: getLineOfBusinessFromPath(isPackagesDisabled, pathname),
              onActiveTabChange: setSelectedTab,
              isMosaicDesign: true,
            }}
          />
        </div>
      </div>
    </div>
  );
};

MosaicHero.propTypes = {
  selectedTab: PropTypes.string.isRequired,
  setSelectedTab: PropTypes.func.isRequired,
  pathname: PropTypes.string.isRequired,
};

export default MosaicHero;
